var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckRound3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8474,
    cy: 14.5896,
    r: 14,
    fill: "#0DD3A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96912 16.3396L10.4691 18.8396M13.9691 14.8396L16.4691 12.3396M11.9691 16.3396L14.4691 18.8396L20.4691 12.3396",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound3);
export default __webpack_public_path__ + "static/media/check-round-3.7c0a71d0b7fddf75f2750cd14acdd1f7.svg";
export { ForwardRef as ReactComponent };